import { FC, MouseEvent, useState } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'libraries/redux'
import { HearthIcon, WishListIcon } from 'assets'
import { addWishlist, deleteWishlist } from 'store/wishlist/actions'

import styles from './ProductCard.module.scss'
import { TProductCardProps } from './types'
import { CategoriesSelectors } from 'store/category/selectors'

const ProductCard: FC<TProductCardProps> = ({ data, className, pageName }) => {
  const dispatch = useAppDispatch()
  const {
    id,
    product_id,
    name,
    in_wishlist: isWishlist,
    price,
    special,
    thumb,
    thumb_small,
    thumb_large,
    isBestSeller,
  } = data

  const [isWishlistAded, setIsWishlistAded] = useState(isWishlist)
  const {data : storeInfo} = useAppSelector(CategoriesSelectors.storeInfo)

  const cleanPrice = (price: string): number => {
    return parseFloat(price.replace(/[^\d.-]/g, ''))
  }

  const handleCardClick = () => {
    if (window.fbq && storeInfo?.fb_pixel_id) {
      window.fbq('track', 'ViewContent', {
        content_ids: [id || product_id],
        content_type: 'product',
      });
    }
    if (window.ttq && storeInfo?.tt_pixel_id) {
      window.ttq.track('ViewContent', {
        content_id: id || product_id,
        content_type: 'product',
        content_name: name,
        value: cleanPrice(price),
        currency: 'UAH',
      });
    }
  }

  const likeLocalHandler = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()

    if (isWishlistAded) {
      try {
        dispatch(deleteWishlist(id || product_id))
        setIsWishlistAded(false)
      } catch (e) {
        console.log(e)
      }
    } else {
      try {
        dispatch(addWishlist(id || product_id))
        setIsWishlistAded(true)
        
        if (window.fbq && storeInfo?.fb_pixel_id) {
          window.fbq('track', 'AddToWishlist', {
            content_ids: [id || product_id],
            content_name: name,
            content_type: 'product',
            value: cleanPrice(price),
            currency: 'UAH',
          });
        }
        if (window.ttq && storeInfo?.tt_pixel_id) {
          window.ttq.track('AddToWishlist', {
            content_id: id || product_id,
            content_name: name,
            content_type: 'product',
            value: cleanPrice(price),
            currency: 'UAH',
          });
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  return (
    <Link to={`/product/${id || product_id}`} onClick={handleCardClick}>
      <div className={classNames(className, styles.container)}>
        <div className={styles.container__image}>
          <div>
            <div className={styles.container__image__status}>
              {special && <span className={styles.container__image__status_discount}>Знижка</span>}
              {isBestSeller && <span className={styles.container__image__status_bestseller}>Бестселер</span>}
            </div>

            <button onClick={e => likeLocalHandler(e)} className={styles.container__image_hearth}>
              {isWishlistAded ? <WishListIcon /> : <HearthIcon />}
            </button>
          </div>
          <div className={styles.container__image_layout}>
            <img src={pageName === 'wishlist' ? thumb_large : isBestSeller ? thumb_small : thumb} alt='product' />
          </div>
        </div>

        <div>
          <p className={styles.container__name}>{name}</p>
          <p className={styles.container__price}>
            {special ? (
              <>
                ₴{special}
                <span className={styles.container__price__save}>₴{price}</span>
                <span className={styles.container__price_save_count}>
                  Заощаджуй {((1 - cleanPrice(special) / cleanPrice(price)) * 100).toFixed(0)}%
                </span>
              </>
            ) : (
              <>₴{price}</>
            )}
          </p>
        </div>
      </div>
    </Link>
  )
}

export default ProductCard
